import { College } from '@backrs_ui/common-ui';

import { appStrings } from '@backrs_ui/grow-ui/src/assets/appStrings';

import { Typography, Box, SxProps, Theme } from '@mui/material';

import { LineIconItem } from '../atoms/LineIconItem';
import { determineCollegeSize, determineDegreeType } from '../college.util';

const SCOOP_STRINGS = appStrings.modules.college.scoop;

type TheScoopProps = Readonly<{
  college: College;
}>;

export const TheScoop = ({ college }: TheScoopProps) => {
  return (
    <Box sx={containerSx}>
      <Box sx={titleContainerSx}>
        <Typography variant="display-sm-medium">{SCOOP_STRINGS.title}</Typography>
      </Box>

      <Box sx={contentContainerSx}>
        <Box sx={summaryContainerSx}>
          <Box>
            <Typography variant="text-md-bold" color={({ backrs }) => backrs.colors['Brand/500']}>
              {SCOOP_STRINGS.bestKnownFor}:{' '}
            </Typography>
            <Typography variant="text-md-regular">{college.scoop_best_known_for}</Typography>
          </Box>

          <Box>
            <Typography variant="text-md-bold" color={({ backrs }) => backrs.colors['Brand/500']}>
              {SCOOP_STRINGS.vibeCheck}:{' '}
            </Typography>
            <Typography variant="text-md-regular">{college.scoop_vibe_check}</Typography>
          </Box>

          <Box>
            <Typography variant="text-md-bold" color={({ backrs }) => backrs.colors['Brand/500']}>
              {SCOOP_STRINGS.opportunitiesNetworks}:{' '}
            </Typography>
            <Typography variant="text-md-regular">
              {college.scoop_opportunities_networks}
            </Typography>
          </Box>
        </Box>

        <Box sx={statsInfoContainerSx}>
          <LineIconItem
            title={SCOOP_STRINGS.enrollment}
            iconName="GraduationHat02"
            text={determineDegreeType(college.predominant_degree)}
          />

          <LineIconItem title={SCOOP_STRINGS.type} iconName="Flag02" text={college.type} />

          <LineIconItem
            title={SCOOP_STRINGS.size}
            iconName="Building08"
            text={determineCollegeSize(college.undergrad_enrollment)}
          />

          <LineIconItem
            title={SCOOP_STRINGS.setting}
            iconName="Building07"
            text={college.setting}
          />
        </Box>
      </Box>
    </Box>
  );
};

const containerSx: SxProps<Theme> = ({ backrs }) => ({
  mb: backrs.spacing['spacing-6xl'],
  borderTop: {
    xs: `1px solid ${backrs.colors['Colors/Foreground/fg-quaternary']}`,
    sm: 'none',
  },
  marginX: backrs.spacing['spacing-4xl'],
  '@media (max-height: 768px)': {
    mx: backrs.spacing['spacing-4xl'],
  },
  '@media (max-width: 414px)': {
    mx: backrs.spacing['spacing-2xl'],
  },
});

const titleContainerSx: SxProps<Theme> = ({ backrs }) => ({
  paddingY: backrs.spacing['spacing-3xl'],
});

const contentContainerSx: SxProps<Theme> = ({ backrs }) => ({
  display: 'flex',
  flexDirection: { xs: 'column-reverse', sm: 'row' },
  gap: backrs.spacing['spacing-4xl'],
});

const summaryContainerSx: SxProps<Theme> = ({ backrs }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: backrs.spacing['spacing-2xl'],
  width: { sm: '66%' },
});

const statsInfoContainerSx: SxProps<Theme> = ({ backrs }) => ({
  display: {
    xs: 'grid',
    sm: 'flex',
  },
  gridTemplateColumns: {
    xs: 'repeat(2, 1fr)',
    sm: '1fr',
  },
  flexDirection: {
    xs: 'row',
    sm: 'column',
  },
  gap: backrs.spacing['spacing-3xl'],
  width: { sm: '33%' },
});
